/* eslint-disable jsx-a11y/img-redundant-alt */
import { Box, Typography } from "@mui/material";
import React, { Fragment } from "react";
import Grid from "@mui/material/Grid";

import { ReactComponent as Instagram } from "../../../static/svg/instagram.svg";
import { ReactComponent as Facebook } from "../../../static/svg/facebook.svg";
import { ReactComponent as Pinterest } from "../../../static/svg/pinterest.svg";
import { ReactComponent as Twitter } from "../../../static/svg/twitter.svg";

import { ReactComponent as YoutubeIcon } from "../../../static/svg/youtube.svg";
import { ReactComponent as SpotifyIcon } from "../../../static/svg/spotify.svg";

import MHButton from "../../Common/Button/MHButton";

type HeaderProps = {
  BgUrl: string;
  ResIconUrl: string;
  title: string;
  titleExt?: string;
  titleInfo: string;
  pageInfo: string;
  isPodcast?: boolean;
  eventSocialClassName: string;
  pageInfoClassName: string;
  titleInfoclassName: string;
  headerClassName: string;
  majorClassName: string;
  boxClassName: string;
  podClassName?: string;
  podClassName2?: string;
  children: React.ReactNode;
};

const AllresHeader = (props: HeaderProps) => {
  return (
    <Fragment>
      <Grid container spacing={0} className={props.headerClassName}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <img
            src={props.BgUrl}
            alt="Header Image"
            style={{
              width: "fit",
              height: "",
            }}
            className="hidden lg:block bg-red-600"
            draggable={false}
          />
          <Box className="" sx={{}}>
            {props.children}
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box className=" z-30">
            <Box className={props.majorClassName}>
              <Box
                className="text-center w-[500px]"
                color="primary"
                sx={{
                  fontWeight: 600,
                  fontSize: "12px",
                  fontFamily: "Area Normal",
                  "& > *": {},
                }}
              >
                <Box className={props.boxClassName} sx={{}}>
                  <img
                    src={props.ResIconUrl}
                    alt="Icon"
                    className="-mt-2 mr-2 "
                    style={{
                      width: "23px",
                      height: "26px",
                    }}
                    draggable={false}
                  />

                  <Box>
                    <Typography
                      variant="caption"
                      className="text-center mx-auto mt-2 uppercase"
                      color="primary"
                      fontSize={{ xs: "11px", sm: "12px" }}
                      lineHeight={{ xs: "120%", sm: "102%" }}
                      letterSpacing={"0.01em"}
                    >
                      {props.title}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="body2"
                  className="text-left pl-8 md:pl-0 mt-1 mb-6 font-semibold font-areaSemi text-xl md:text-[24px]"
                  color="primary"
                >
                  {props.titleExt}
                </Typography>
                <Typography
                  variant="h3"
                  className={props.titleInfoclassName}
                  color="primary"
                >
                  {props.titleInfo}
                </Typography>
                <Typography
                  variant="body2"
                  color="primary"
                  className={props.pageInfoClassName}
                >
                  {props.pageInfo}
                </Typography>

                {props.isPodcast && (
                  <Box
                    display={{ xs: "grid", sm: "flex" }}
                    justifyContent="left"
                    mt={3}
                    gap={2}
                  >
                    <Box>
                      <MHButton
                        onClick={() =>
                          window.open(
                            "https://open.spotify.com/show/43MizJhEeMXjPQG2afWoxR",
                            "_blank",
                          )
                        }
                        sx={{
                          color: "primary.main",
                          backgroundColor: "#fff",
                          borderRadius: "36px",
                          border: 2,
                          borderColor: "#ccc",
                          "&:hover": {
                            backgroundColor: "#fff",
                            color: "primary.main",
                          },
                        }}
                        startIcon={<SpotifyIcon />}
                        className="w-full md:w-[250px] h-10 md:h-[45px] font-areaExt text-[10px] md:text-xs"
                      >
                        Listen on Spotify
                      </MHButton>
                    </Box>
                    <Box>
                      <MHButton
                        onClick={() =>
                          window.open(
                            "https://youtube.com/playlist?list=PLhQkIzHrjgtF4XHgnYW5QEs-vts6Etkax&si=iu2c4EWZ7Rx2lWub",
                            "_blank",
                          )
                        }
                        sx={{
                          color: "primary.main",
                          backgroundColor: "#fff",
                          borderRadius: "36px",
                          border: 2,
                          borderColor: "#ccc",
                          "&:hover": {
                            backgroundColor: "#fff",
                            color: "primary.main",
                          },
                        }}
                        startIcon={<YoutubeIcon />}
                        className="w-full md:w-[250px] h-10 md:h-[45px] font-areaExt text-[10px] md:text-xs"
                      >
                        Watch on YouTube
                      </MHButton>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>

            <Box className={props.eventSocialClassName}>
              {/* Web */}
              <Box className="absolute gap-4 bottom-8 md:bottom-12 text-center place-content-center hidden md:flex md:right-20">
                <a
                  className="cursor-pointer"
                  href="https://instagram.com/mhworklife?igshid=YmMyMTA2M2Y="
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Instagram />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.facebook.com/motherhonestly?mibextid=LQQJ4d"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Facebook />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.pinterest.com/motherhonestly/"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Pinterest />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://twitter.com/mhworklife?s=21&t=lhmzHgRp7adyrrMjPPyrsw"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Twitter />
                </a>
              </Box>
              {/* Mobile */}
              <Box className="absolute gap-4 bottom-8 md:bottom-12 text-center place-content-center flex md:hidden right-0 left-0">
                <a
                  className="cursor-pointer"
                  href="https://instagram.com/mhworklife?igshid=YmMyMTA2M2Y="
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Instagram />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.facebook.com/motherhonestly?mibextid=LQQJ4d"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Facebook />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://www.pinterest.com/motherhonestly/"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Pinterest />
                </a>
                <a
                  className="cursor-pointer"
                  href="https://twitter.com/mhworklife?s=21&t=lhmzHgRp7adyrrMjPPyrsw"
                  target="_blanc"
                  title="Visit our socials"
                >
                  <Twitter />
                </a>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default AllresHeader;
